/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FleetYards.net API
 * OpenAPI spec version: v1
 */
import {
  useMutation,
  useQuery
} from '@tanstack/vue-query';
import type {
  DataTag,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UseMutationOptions,
  UseMutationReturnType,
  UseQueryOptions,
  UseQueryReturnType
} from '@tanstack/vue-query';

import {
  toValue,
  unref
} from 'vue';
import type {
  MaybeRefOrGetter
} from 'vue';

import type {
  HangarGroup,
  HangarGroupCreateInput,
  HangarGroupSortInput,
  HangarGroupUpdateInput,
  HangarGroupsList,
  SchemaValidationErrorResponse,
  StandardError,
  SuccessResponse
} from '../../models';

import { axiosClient } from '../../../axiosClient.ts';
import type { ErrorType } from '../../../axiosClient.ts';




/**
 * @summary HangarGroup create
 */
export const createHangarGroup = (
    hangarGroupCreateInput: MaybeRefOrGetter<HangarGroupCreateInput>,
 signal?: AbortSignal
) => {
      hangarGroupCreateInput = toValue(hangarGroupCreateInput);

      return axiosClient<HangarGroup>(
      {url: `/hangar/groups`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: hangarGroupCreateInput, signal
    },
      );
    }




export const getCreateHangarGroupMutationKey = () => ['createHangarGroup'] as const;

export const getCreateHangarGroupMutationOptions = <TError = ErrorType<SchemaValidationErrorResponse | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createHangarGroup>>, TError,CreateHangarGroupMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof createHangarGroup>>, TError,CreateHangarGroupMutationVariables, TContext> => {

const mutationKey = getCreateHangarGroupMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createHangarGroup>>, CreateHangarGroupMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  createHangarGroup(data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateHangarGroupMutationResult = NonNullable<Awaited<ReturnType<typeof createHangarGroup>>>
    export type CreateHangarGroupMutationBody = HangarGroupCreateInput
    export type CreateHangarGroupMutationError = ErrorType<SchemaValidationErrorResponse | StandardError>
    export type CreateHangarGroupMutationVariables = {data: HangarGroupCreateInput}

    /**
 * @summary HangarGroup create
 */
export const useCreateHangarGroup = <TError = ErrorType<SchemaValidationErrorResponse | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createHangarGroup>>, TError,CreateHangarGroupMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof createHangarGroup>>,
        TError,
        CreateHangarGroupMutationVariables,
        TContext
      > => {
      return useMutation(getCreateHangarGroupMutationOptions(options), queryClient);
    }
    /**
 * @summary HangarGroup list
 */
export const hangarGroups = (

 signal?: AbortSignal
) => {


      return axiosClient<HangarGroupsList>(
      {url: `/hangar/groups`, method: 'GET', signal
    },
      );
    }




export const getHangarGroupsQueryKey = () => {
    return [
    'hangar','groups'
    ] as const;
    }


export const getHangarGroupsQueryOptions = <TData = Awaited<ReturnType<typeof hangarGroups>>, TError = ErrorType<StandardError>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof hangarGroups>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getHangarGroupsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof hangarGroups>>> = ({ signal }) => hangarGroups(signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof hangarGroups>>, TError, TData>
}

export type HangarGroupsQueryResult = NonNullable<Awaited<ReturnType<typeof hangarGroups>>>
export type HangarGroupsQueryError = ErrorType<StandardError>


/**
 * @summary HangarGroup list
 */

export function useHangarGroups<TData = Awaited<ReturnType<typeof hangarGroups>>, TError = ErrorType<StandardError>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof hangarGroups>>, TError, TData>>, }
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getHangarGroupsQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}






/**
 * @summary HangarGroup sort
 */
export const hangarGroupSort = (
    hangarGroupSortInput: MaybeRefOrGetter<HangarGroupSortInput>,
 signal?: AbortSignal
) => {
      hangarGroupSortInput = toValue(hangarGroupSortInput);

      return axiosClient<SuccessResponse>(
      {url: `/hangar/groups/sort`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: hangarGroupSortInput, signal
    },
      );
    }




export const getHangarGroupSortMutationKey = () => ['hangarGroupSort'] as const;

export const getHangarGroupSortMutationOptions = <TError = ErrorType<SchemaValidationErrorResponse | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof hangarGroupSort>>, TError,HangarGroupSortMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof hangarGroupSort>>, TError,HangarGroupSortMutationVariables, TContext> => {

const mutationKey = getHangarGroupSortMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof hangarGroupSort>>, HangarGroupSortMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  hangarGroupSort(data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type HangarGroupSortMutationResult = NonNullable<Awaited<ReturnType<typeof hangarGroupSort>>>
    export type HangarGroupSortMutationBody = HangarGroupSortInput
    export type HangarGroupSortMutationError = ErrorType<SchemaValidationErrorResponse | StandardError>
    export type HangarGroupSortMutationVariables = {data: HangarGroupSortInput}

    /**
 * @summary HangarGroup sort
 */
export const useHangarGroupSort = <TError = ErrorType<SchemaValidationErrorResponse | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof hangarGroupSort>>, TError,HangarGroupSortMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof hangarGroupSort>>,
        TError,
        HangarGroupSortMutationVariables,
        TContext
      > => {
      return useMutation(getHangarGroupSortMutationOptions(options), queryClient);
    }
    /**
 * @summary HangarGroup Destroy
 */
export const destroyHangarGroup = (
    id: MaybeRefOrGetter<string>,
 signal?: AbortSignal
) => {
      id = toValue(id);

      return axiosClient<HangarGroup>(
      {url: `/hangar/groups/${id}`, method: 'DELETE', signal
    },
      );
    }




export const getDestroyHangarGroupMutationKey = () => ['destroyHangarGroup'] as const;

export const getDestroyHangarGroupMutationOptions = <TError = ErrorType<SchemaValidationErrorResponse | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof destroyHangarGroup>>, TError,DestroyHangarGroupMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof destroyHangarGroup>>, TError,DestroyHangarGroupMutationVariables, TContext> => {

const mutationKey = getDestroyHangarGroupMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof destroyHangarGroup>>, DestroyHangarGroupMutationVariables> = (props) => {
          const {id} = props ?? {};

          return  destroyHangarGroup(id,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DestroyHangarGroupMutationResult = NonNullable<Awaited<ReturnType<typeof destroyHangarGroup>>>

    export type DestroyHangarGroupMutationError = ErrorType<SchemaValidationErrorResponse | StandardError>
    export type DestroyHangarGroupMutationVariables = {id: string}

    /**
 * @summary HangarGroup Destroy
 */
export const useDestroyHangarGroup = <TError = ErrorType<SchemaValidationErrorResponse | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof destroyHangarGroup>>, TError,DestroyHangarGroupMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof destroyHangarGroup>>,
        TError,
        DestroyHangarGroupMutationVariables,
        TContext
      > => {
      return useMutation(getDestroyHangarGroupMutationOptions(options), queryClient);
    }
    /**
 * @summary HangarGroup Update
 */
export const updateHangarGroup = (
    id: MaybeRefOrGetter<string>,
    hangarGroupUpdateInput: MaybeRefOrGetter<HangarGroupUpdateInput>,
 signal?: AbortSignal
) => {
      id = toValue(id);
hangarGroupUpdateInput = toValue(hangarGroupUpdateInput);

      return axiosClient<HangarGroup>(
      {url: `/hangar/groups/${id}`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: hangarGroupUpdateInput, signal
    },
      );
    }




export const getUpdateHangarGroupMutationKey = () => ['updateHangarGroup'] as const;

export const getUpdateHangarGroupMutationOptions = <TError = ErrorType<SchemaValidationErrorResponse | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateHangarGroup>>, TError,UpdateHangarGroupMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof updateHangarGroup>>, TError,UpdateHangarGroupMutationVariables, TContext> => {

const mutationKey = getUpdateHangarGroupMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateHangarGroup>>, UpdateHangarGroupMutationVariables> = (props) => {
          const {id,data} = props ?? {};

          return  updateHangarGroup(id,data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateHangarGroupMutationResult = NonNullable<Awaited<ReturnType<typeof updateHangarGroup>>>
    export type UpdateHangarGroupMutationBody = HangarGroupUpdateInput
    export type UpdateHangarGroupMutationError = ErrorType<SchemaValidationErrorResponse | StandardError>
    export type UpdateHangarGroupMutationVariables = {id: string;data: HangarGroupUpdateInput}

    /**
 * @summary HangarGroup Update
 */
export const useUpdateHangarGroup = <TError = ErrorType<SchemaValidationErrorResponse | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateHangarGroup>>, TError,UpdateHangarGroupMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof updateHangarGroup>>,
        TError,
        UpdateHangarGroupMutationVariables,
        TContext
      > => {
      return useMutation(getUpdateHangarGroupMutationOptions(options), queryClient);
    }
